export class LoveLetters {
  loveLettersRoot: HTMLElement | null;

  constructor() {
    this.loveLettersRoot = null;
  }

  addLetter(letter: string, listLength: number) {
    const lettersBlock = document.querySelector("#letters-wrapper");

    const p = document.createElement("p");
    p.textContent = letter;
    p?.classList?.add("letter-animation", "letter-animation-enter");

    if (lettersBlock) {
      lettersBlock.appendChild(p);
      this.updateOpacity(listLength);
    }

    setTimeout(() => {
      p?.classList?.remove("letter-animation-enter");
      p?.addEventListener("transitioned", () => {
        this.updateOpacity(listLength);
      });
    }, 1000);
  }

  updateOpacity(listLength: number) {
    const letters = document.querySelectorAll("#letters-block p");
    const maxOpacity = 0.6;
    const minOpacity = 0;
    const multiplyCoeficient = 1.2 / letters.length;

    letters.forEach((letter, index) => {
      const htmlLetter = letter as HTMLElement;
      const reverseIndex = letters.length - 1 - index;
      const opacity = maxOpacity - reverseIndex * multiplyCoeficient * (maxOpacity - minOpacity);
      if (listLength !== index + 1) {
        htmlLetter.style.opacity = Math.max(minOpacity, opacity).toString();
        htmlLetter?.classList?.add("letter-animation-exit");
      } else {
        htmlLetter.style.opacity = "1";
      }
    });
  }
}
